import { render, staticRenderFns } from "./nodeProductAccount.vue?vue&type=template&id=b6b65ac2&scoped=true&"
import script from "./nodeProductAccount.vue?vue&type=script&lang=js&"
export * from "./nodeProductAccount.vue?vue&type=script&lang=js&"
import style0 from "./nodeProductAccount.vue?vue&type=style&index=0&id=b6b65ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b65ac2",
  null
  
)

export default component.exports